import type { UserState } from 'src/types/user';

import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

const initialUserState = {
  id: null,
  firstName: null,
  lastName: null,
  email: null,
  emailVerified: null,
  emailVerificationToken: null,
  emailVerificationTokenExpiresAt: null,
  phone: null,
  orgName: null,
  userApps: [],
  orgs: [],
  collaborators: null,
  loading: {},
  subscription: null,
};

type Actions = {
  reset: () => void;
};

export const userModel = create(
  persist<UserState & Actions & { loading: Record<string, boolean> }>(
    (set) => ({
      ...initialUserState,
      reset: () => {
        set(initialUserState);
      },
    }),
    {
      name: 'sc-user-storage',
      storage: createJSONStorage(() => localStorage),
    }
  )
);
